"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _reactHooks = require("@trycourier/react-hooks");

var _reactProvider = require("@trycourier/react-provider");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useLocalStorageMessages = function useLocalStorageMessages(clientKey, userId) {
  var _useCourier = (0, _reactProvider.useCourier)(),
      localStorage = _useCourier.localStorage;

  var _useInbox = (0, _reactHooks.useInbox)(),
      lastMessagesFetched = _useInbox.lastMessagesFetched,
      messages = _useInbox.messages,
      rehydrateMessages = _useInbox.rehydrateMessages,
      startCursor = _useInbox.startCursor,
      tabs = _useInbox.tabs,
      unreadMessageCount = _useInbox.unreadMessageCount;

  var localStorageKey = (0, _react.useMemo)(function () {
    if (!clientKey || !userId) {
      return;
    }

    return "".concat(clientKey, "/").concat(userId, "/messages");
  }, [clientKey, userId]);
  (0, _react.useEffect)(function () {
    if (!localStorageKey || !localStorage) {
      return;
    }

    var localStorageState = localStorage.getItem(localStorageKey);

    if (localStorageState) {
      try {
        var _JSON$parse = JSON.parse(localStorageState),
            _lastMessagesFetched = _JSON$parse.lastMessagesFetched,
            _unreadMessageCount = _JSON$parse.unreadMessageCount,
            _messages = _JSON$parse.messages,
            _tabs = _JSON$parse.tabs,
            _startCursor = _JSON$parse.startCursor;

        rehydrateMessages({
          lastMessagesFetched: _lastMessagesFetched,
          messages: _messages,
          startCursor: _startCursor,
          tabs: _tabs,
          unreadMessageCount: _unreadMessageCount
        });
      } catch (ex) {
        console.log("error", ex);
      }
    }
  }, [localStorageKey, localStorage]);
  (0, _react.useEffect)(function () {
    if (!localStorageKey || !localStorage) {
      return;
    }

    localStorage.setItem(localStorageKey, JSON.stringify({
      lastMessagesFetched: lastMessagesFetched,
      messages: messages,
      startCursor: startCursor,
      unreadMessageCount: unreadMessageCount,
      tabs: tabs === null || tabs === void 0 ? void 0 : tabs.map(function (tab) {
        if (!tab.state) {
          return tab;
        }

        var tabState = tab.state;
        return _objectSpread(_objectSpread({}, tab), {}, {
          state: {
            messages: tabState === null || tabState === void 0 ? void 0 : tabState.messages,
            startCursor: tabState.startCursor
          }
        });
      })
    }));
  }, [localStorageKey, localStorage, messages, startCursor, tabs, unreadMessageCount]);
};

var _default = useLocalStorageMessages;
exports["default"] = _default;